function refreshCartSavingsProgressCollapse() {
  if (window.CartSavingsProgressCollapse && typeof window.CartSavingsProgressCollapse.refresh === 'function') {
    window.CartSavingsProgressCollapse.refresh();
  }
}

let cartSavingsProgressPaintRaf = 0;
let cartSavingsProgressIntroStartTimer = 0;
let cartSavingsProgressIntroTimer = 0;
let cartSavingsProgressMessageTimer = 0;
let cartSavingsProgressMessageSwitchTimer = 0;
let cartSavingsProgressConfettiTimer = 0;
let cartSavingsProgressConfettiEl = null;
const CART_SAVINGS_INTRO_PENDING_MS = 420;
const CART_SAVINGS_INTRO_SEGMENT_MS = 620;
const CART_SAVINGS_INTRO_BADGE_MS = 560;
const CART_SAVINGS_MESSAGE_HOLD_MS = 5000;
const CART_SAVINGS_MESSAGE_FADE_MS = 450;
const CART_SAVINGS_CONFETTI_MS = 3300;
const CART_SAVINGS_CONFETTI_THRESHOLD = 300000;
const CART_SAVINGS_INTRO_SEGMENT_DELAYS = [680, 1380, 2080];
const CART_SAVINGS_INTRO_BADGE_DELAYS = {
  300000: 260,
  500000: 960,
  1000000: 1660,
  2000000: 2360,
};

function getCartSavingsIntroCard(root = document) {
  return root.querySelector?.('[data-cart-savings-progress]');
}

function shouldRunCartSavingsIntro(card) {
  if (!card || window.__dtCartSavingsProgressIntroPlayed) return false;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return false;
  if (hasCartSavingsDiscountUnlocked(card)) return true;
  return Array.from(card.querySelectorAll('[data-cart-savings-segment-fill]')).some((segment) => {
    const scale = parseFloat(segment.style.getPropertyValue('--segment-fill-scale') || '0');
    return scale > 0;
  });
}

function prepareCartSavingsProgressIntro(root = document) {
  const card = getCartSavingsIntroCard(root);
  if (!shouldRunCartSavingsIntro(card)) return false;

  const drawer = card.closest('cart-drawer, #CartDrawer');
  drawer?.classList.add('is-cart-savings-intro-active');
  card.classList.remove('is-cart-savings-intro-playing', 'is-cart-savings-message-entering', 'is-cart-savings-message-intro-playing', 'is-cart-savings-message-intro-visible', 'is-cart-savings-message-switching');
  setCartSavingsIntroMessage(card, true);
  card.classList.add('is-cart-savings-intro-pending');
  scheduleCartSavingsIntroMessageRotation(card);
  requestAnimationFrame(() => {
    if (!card.isConnected || !card.classList.contains('is-cart-savings-intro-pending')) return;
    card.classList.add('is-cart-savings-message-intro-playing', 'is-cart-savings-message-intro-visible');
  });
  return true;
}

function hasCartSavingsDiscountUnlocked(card) {
  if (!card) return false;

  const cartValue = Number(card.getAttribute('data-cart-value') || 0);
  if (cartValue >= CART_SAVINGS_CONFETTI_THRESHOLD) return true;

  const firstThreshold = card.querySelector(`[data-threshold="${CART_SAVINGS_CONFETTI_THRESHOLD}"].is-unlocked`);
  return Boolean(firstThreshold);
}

function getCartSavingsUnlockedDiscount(card) {
  if (!card) return '';

  const unlockedBadges = Array.from(card.querySelectorAll('[data-cart-savings-percent].is-unlocked'));
  const lastUnlockedBadge = unlockedBadges[unlockedBadges.length - 1];
  return lastUnlockedBadge?.textContent?.trim() || '';
}

function setCartSavingsIntroMessage(card, useIntroMessage) {
  if (!card) return;

  const discount = getCartSavingsUnlockedDiscount(card);
  const introMessage = discount
    ? `Congratulations! You've unlocked <strong class="cart-savings-progress__offer">${discount}</strong> Discount!`
    : '';

  card.querySelectorAll('[data-cart-savings-message]').forEach((messageEl) => {
    if (!messageEl.dataset.cartSavingsDefaultHtml) {
      messageEl.dataset.cartSavingsDefaultHtml = messageEl.innerHTML;
    }

    if (useIntroMessage && introMessage) {
      messageEl.innerHTML = introMessage;
      return;
    }

    messageEl.innerHTML = messageEl.dataset.cartSavingsDefaultHtml || messageEl.innerHTML;
  });
}

function clearCartSavingsIntroMessageTimers() {
  if (cartSavingsProgressMessageTimer) {
    clearTimeout(cartSavingsProgressMessageTimer);
    cartSavingsProgressMessageTimer = 0;
  }

  if (cartSavingsProgressMessageSwitchTimer) {
    clearTimeout(cartSavingsProgressMessageSwitchTimer);
    cartSavingsProgressMessageSwitchTimer = 0;
  }
}

function completeCartSavingsMessageSwitch(card, useIntroMessage) {
  if (!card) return;

  setCartSavingsIntroMessage(card, useIntroMessage);
  card.classList.remove('is-cart-savings-message-switching');
  card.classList.add('is-cart-savings-message-entering');
  card.classList.toggle('is-cart-savings-message-intro-visible', useIntroMessage);
}

function queueCartSavingsIntroMessageRotation(card, useIntroMessage) {
  if (!card) return;

  cartSavingsProgressMessageTimer = setTimeout(() => {
    cartSavingsProgressMessageTimer = 0;
    if (!card.isConnected) return;

    card.classList.remove('is-cart-savings-message-entering', 'is-cart-savings-message-intro-playing');
    card.classList.add('is-cart-savings-message-switching');
    card.classList.toggle('is-cart-savings-message-intro-visible', useIntroMessage);

    cartSavingsProgressMessageSwitchTimer = setTimeout(() => {
      cartSavingsProgressMessageSwitchTimer = 0;
      if (!card.isConnected) return;

      completeCartSavingsMessageSwitch(card, useIntroMessage);
      cartSavingsProgressMessageSwitchTimer = setTimeout(() => {
        cartSavingsProgressMessageSwitchTimer = 0;
        if (!card.isConnected) return;

        card.classList.remove('is-cart-savings-message-entering');
        queueCartSavingsIntroMessageRotation(card, !useIntroMessage);
      }, CART_SAVINGS_MESSAGE_FADE_MS);
    }, CART_SAVINGS_MESSAGE_FADE_MS);
  }, CART_SAVINGS_MESSAGE_HOLD_MS);
}

function scheduleCartSavingsIntroMessageRotation(card) {
  clearCartSavingsIntroMessageTimers();
  if (!card) return;

  queueCartSavingsIntroMessageRotation(card, false);
}

function resetCartSavingsConfetti(card) {
  const confetti = card?.querySelector?.('[data-cart-savings-confetti]');
  if (cartSavingsProgressConfettiTimer) {
    clearTimeout(cartSavingsProgressConfettiTimer);
    cartSavingsProgressConfettiTimer = 0;
  }
  if (cartSavingsProgressConfettiEl) {
    cartSavingsProgressConfettiEl.remove();
    cartSavingsProgressConfettiEl = null;
  }
  if (!confetti) return null;

  confetti.classList.remove('is-active');
  return confetti;
}

function playCartSavingsConfetti(card) {
  if (!hasCartSavingsDiscountUnlocked(card)) return;
  if (window.__dtCartSavingsConfettiPlayed) return;
  if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;

  const confettiSource = resetCartSavingsConfetti(card);
  if (!confettiSource) return;

  window.__dtCartSavingsConfettiPlayed = true;

  const confetti = confettiSource.cloneNode(true);
  confetti.removeAttribute('data-cart-savings-confetti');
  confetti.setAttribute('data-cart-savings-confetti-active', '');
  document.body.appendChild(confetti);
  cartSavingsProgressConfettiEl = confetti;
  confetti.getBoundingClientRect();
  confetti.classList.add('is-active');

  cartSavingsProgressConfettiTimer = setTimeout(() => {
    confetti.remove();
    if (cartSavingsProgressConfettiEl === confetti) {
      cartSavingsProgressConfettiEl = null;
    }
    cartSavingsProgressConfettiTimer = 0;
  }, CART_SAVINGS_CONFETTI_MS);
}

function playCartSavingsProgressIntro(root = document) {
  const card = getCartSavingsIntroCard(root);
  if (!shouldRunCartSavingsIntro(card)) return;
  const drawer = card.closest('cart-drawer, #CartDrawer');

  window.__dtCartSavingsProgressIntroPlayed = true;

  if (cartSavingsProgressIntroStartTimer) {
    clearTimeout(cartSavingsProgressIntroStartTimer);
  }
  if (cartSavingsProgressIntroTimer) {
    clearTimeout(cartSavingsProgressIntroTimer);
  }

  drawer?.classList.add('is-cart-savings-intro-active');
  card.classList.remove('is-cart-savings-intro-playing');
  resetCartSavingsConfetti(card);
  setCartSavingsIntroMessage(card, true);
  card.classList.add('is-cart-savings-intro-pending');

  cartSavingsProgressIntroStartTimer = setTimeout(() => {
    cartSavingsProgressIntroStartTimer = 0;
    if (!card.isConnected) {
      drawer?.classList.remove('is-cart-savings-intro-active');
      return;
    }

    card.classList.remove('is-cart-savings-intro-pending');
    card.getBoundingClientRect();
    card.classList.add('is-cart-savings-intro-playing');

    cartSavingsProgressIntroTimer = setTimeout(() => {
      card.classList.remove('is-cart-savings-intro-playing');
      drawer?.classList.remove('is-cart-savings-intro-active');
      playCartSavingsConfetti(card);
      cartSavingsProgressIntroTimer = 0;
    }, getCartSavingsIntroDuration(card));
  }, CART_SAVINGS_INTRO_PENDING_MS);
}

function getCartSavingsIntroDuration(card) {
  let duration = 0;

  card.querySelectorAll('[data-cart-savings-segment-fill]').forEach((segment) => {
    const scale = parseFloat(segment.style.getPropertyValue('--segment-fill-scale') || '0');
    if (scale <= 0) return;

    const index = Number(segment.getAttribute('data-segment-index'));
    const delay = CART_SAVINGS_INTRO_SEGMENT_DELAYS[index] || 0;
    duration = Math.max(duration, delay + CART_SAVINGS_INTRO_SEGMENT_MS);
  });

  card.querySelectorAll('[data-threshold].is-unlocked').forEach((badge) => {
    const threshold = Number(badge.getAttribute('data-threshold'));
    const delay = CART_SAVINGS_INTRO_BADGE_DELAYS[threshold] || 0;
    duration = Math.max(duration, delay + CART_SAVINGS_INTRO_BADGE_MS);
  });

  return duration;
}

function isEasyBundlePage() {
  return window.location.pathname.indexOf('/apps/gbb/easybundle/') === 0;
}

function bindEasyBundleCartDrawerDismissal(attempt = 0) {
  if (!isEasyBundlePage() || window.__dtEasyBundleCartDrawerDismissObserverBound) return;

  const drawer = document.querySelector('cart-drawer');
  if (!drawer) {
    // EasyBundle app pages can mount the drawer after this asset executes.
    if (attempt < 20) {
      window.setTimeout(() => bindEasyBundleCartDrawerDismissal(attempt + 1), 100);
    }
    return;
  }
  if (!('MutationObserver' in window)) return;

  window.__dtEasyBundleCartDrawerDismissObserverBound = true;
  let wasActive = drawer.classList.contains('active');
  if (wasActive) window.__dtEasyBundleCartDrawerOpenedOnce = true;

  new MutationObserver(() => {
    const isActive = drawer.classList.contains('active');
    if (isActive) {
      window.__dtEasyBundleCartDrawerOpenedOnce = true;
    } else if (wasActive && window.__dtEasyBundleCartDrawerOpenedOnce) {
      window.__dtEasyBundleCartDrawerDismissed = true;
    }
    wasActive = isActive;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindEasyBundleCartDrawerDismissal);
} else {
  bindEasyBundleCartDrawerDismissal();
}

function refreshCartSavingsProgressCollapseAfterPaint() {
  if (cartSavingsProgressPaintRaf) {
    cancelAnimationFrame(cartSavingsProgressPaintRaf);
  }

  cartSavingsProgressPaintRaf = requestAnimationFrame(() => {
    cartSavingsProgressPaintRaf = 0;
    refreshCartSavingsProgressCollapse();
  });
}

var CartDrawer = window.CartDrawer || class CartDrawer extends HTMLElement {
  constructor() {
    super();
    bindEasyBundleCartDrawerDismissal();

    this.addEventListener('keyup', (evt) => {
      if (evt.code === 'Escape') {
        // Close info section if open
        const openIcon = this.querySelector('.price-breakdown__info-icon[aria-expanded="true"]');
        if (openIcon) {
          const sectionId = openIcon.getAttribute('aria-controls');
          if (sectionId) {
            const section = this.querySelector(`#${sectionId}`);
            if (section) {
              this.closePriceBreakdownInfo(openIcon, section);
              return;
            }
          }
        }
        // Close drawer if no info section is open
        this.close();
      }
    });
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    const iconsearch = document.querySelector(".header__search");
    if (iconsearch)
      iconsearch.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    const iconaccount = document.querySelector(".header__icon--account");
    if (iconaccount)
      iconaccount.addEventListener("click", () => {
        this.classList.contains("active") && this.close();
      });

    this.stickyHeaderAvailable = document.querySelector('sticky-header') ? true : false;
    this.hiddenElements = [];
    this.afterOpenCallbacks = [];
    // Handle price breakdown info icon expandable section
    this.addEventListener('click', (e) => {
      const infoIcon = e.target.closest('.price-breakdown__info-icon');
      if (infoIcon) {
        e.preventDefault();
        e.stopPropagation();

        const infoSectionId = infoIcon.getAttribute('aria-controls');
        if (!infoSectionId) return;

        const infoSection = this.querySelector(`#${infoSectionId}`);
        if (!infoSection) return;

        // Close any other open sections first
        const allOpenIcons = this.querySelectorAll('.price-breakdown__info-icon[aria-expanded="true"]');
        allOpenIcons.forEach(icon => {
          if (icon !== infoIcon) {
            const otherSectionId = icon.getAttribute('aria-controls');
            if (otherSectionId) {
              const otherSection = this.querySelector(`#${otherSectionId}`);
              if (otherSection) {
                this.closePriceBreakdownInfo(icon, otherSection);
              }
            }
          }
        });

        // Toggle the clicked section
        const isExpanded = infoIcon.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          this.closePriceBreakdownInfo(infoIcon, infoSection);
        } else {
          this.openPriceBreakdownInfo(infoIcon, infoSection);
        }
      } else {
        // Close section if clicking outside
        const openIcon = this.querySelector('.price-breakdown__info-icon[aria-expanded="true"]');
        if (openIcon) {
          const sectionId = openIcon.getAttribute('aria-controls');
          if (sectionId) {
            const section = this.querySelector(`#${sectionId}`);
            if (section) {
              this.closePriceBreakdownInfo(openIcon, section);
            }
          }
        }
      }
    });


  }

  openPriceBreakdownInfo(icon, section) {
    if (!icon || !section) return;

    if (section._dtInfoCloseTimer) {
      window.clearTimeout(section._dtInfoCloseTimer);
      section._dtInfoCloseTimer = null;
    }

    icon.setAttribute('aria-expanded', 'true');
    section.hidden = false;
    section.classList.remove('is-closing');

    requestAnimationFrame(() => {
      section.classList.add('is-open');
    });
  }

  closePriceBreakdownInfo(icon, section) {
    if (!icon || !section) return;

    icon.setAttribute('aria-expanded', 'false');
    section.classList.remove('is-open');
    section.classList.add('is-closing');

    if (section._dtInfoCloseTimer) {
      window.clearTimeout(section._dtInfoCloseTimer);
    }

    section._dtInfoCloseTimer = window.setTimeout(() => {
      section.hidden = true;
      section.classList.remove('is-closing');
      section._dtInfoCloseTimer = null;
    }, 260);
  }

  connectedCallback() {
    let stickyHeaderHeight = 0;
    document.querySelectorAll('.section-header').forEach(ele => {
      stickyHeaderHeight += ele.getBoundingClientRect().height;
    });
    let headerHeight = stickyHeaderHeight;
    document.querySelectorAll('.utility-bar').forEach(ele => {
      headerHeight += ele.getBoundingClientRect().height;
    });
    document.documentElement.style.setProperty('--header-announce-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-sticky-height', stickyHeaderHeight + 'px');

    // Set dynamic viewport height for mobile devices
    this.setMobileViewportHeight();
    window.addEventListener('resize', () => this.setMobileViewportHeight());
    window.addEventListener('orientationchange', () => {
      setTimeout(() => this.setMobileViewportHeight(), 100);
    });

    // Check for gifts when drawer initializes
    fetch('/cart.js')
      .then(res => res.json())
      .then(data => {
        // Also update totals just in case
        this.updateTotals(data);
      })
      .catch(e => console.error('[CartDrawer] Init fetch failed', e));




    // Also listen for custom cart:updated events
    this.cartUpdatedHandler = (event) => {
      if (event.detail && event.detail.total_price) {
        // Refresh totals when cart is updated (including discount changes)
        this.updateTotals(event.detail);
      }
    };
    document.addEventListener('cart:updated', this.cartUpdatedHandler);
    // Checkout: prevent double-clicks only; no loading state so button always looks ready.
    // Form submits immediately; browser handles navigation. On 3G, user sees browser loading, not a stuck spinner.
    this.checkoutSubmitHandler = async (evt) => {
      if (evt.target.id !== 'CartDrawer-Form') return;
      const submitter = evt.submitter;
      if (submitter && submitter.id === 'CartDrawer-Checkout' && submitter.name === 'checkout') {
        if (evt.target.dataset.cartMutationsFlushed !== 'true'
          && window.CartController
          && typeof window.CartController.flushPendingCartMutations === 'function'
          && (window.CartController.pendingRemovalKeys?.size || window.CartController.pendingQuantityUpdates?.size || window.CartController.pendingQuantityPromise || window.CartController.pendingAddQueue?.length || window.CartController.pendingAddPromise)) {
          evt.preventDefault();
          submitter.setAttribute('data-checkout-loading', 'true');
          const synced = await window.CartController.flushPendingCartMutations();
          if (!synced) {
            submitter.setAttribute('data-checkout-loading', 'false');
            return;
          }
          evt.target.dataset.cartMutationsFlushed = 'true';
          if (evt.target.requestSubmit) {
            evt.target.requestSubmit(submitter);
          } else {
            evt.target.submit();
          }
          window.setTimeout(() => {
            delete evt.target.dataset.cartMutationsFlushed;
          }, 0);
          return;
        }
        if (submitter.getAttribute('data-checkout-loading') === 'true') {
          evt.preventDefault();
          return;
        }
        submitter.setAttribute('data-checkout-loading', 'true');
        // Reset flag after 3s so user can retry if navigation never happened (e.g. network failure)
        this.checkoutTimeoutId = setTimeout(() => {
          if (submitter.isConnected) submitter.setAttribute('data-checkout-loading', 'false');
        }, 3000);
      }
    };
    this.addEventListener('submit', this.checkoutSubmitHandler);
  }

  disconnectedCallback() {
    // Clean up event listeners
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.cartUpdatedHandler) {
      document.removeEventListener('cart:updated', this.cartUpdatedHandler);
    }
    if (this.checkoutSubmitHandler) {
      this.removeEventListener('submit', this.checkoutSubmitHandler);
    }
    if (this.checkoutTimeoutId) {
      clearTimeout(this.checkoutTimeoutId);
    }
  }

  setMobileViewportHeight() {
    // Use actual window height for mobile to account for browser chrome
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.contains("active") ? this.close() : this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  startOpeningTransition() {
    this.cancelOpeningTransition();
    this.classList.remove('is-settled');
    this.classList.add('is-opening');
    this.afterOpenCallbacks = [];
    this.dispatchEvent(new CustomEvent('cart-drawer:opening', { bubbles: true }));
  }

  skipOpeningTransition() {
    this.cancelOpeningTransition();
    this.classList.remove('is-opening');
    this.classList.add('is-settled');
    this.afterOpenCallbacks = [];
  }

  closeDrawerMiniTabs() {
    const drawerMini = this.querySelector('.drawer_mini');
    if (!drawerMini) return;

    drawerMini.querySelector('.drawericon')?.classList.remove('active');
    drawerMini.querySelectorAll('.drawer_tab.active, .drawericon_inner.active').forEach((element) => {
      element.classList.remove('active');
    });

    if ('prevTag' in drawerMini) {
      drawerMini.prevTag = '';
    }
  }

  cancelOpeningTransition() {
    if (this.openingFallbackId) {
      clearTimeout(this.openingFallbackId);
      this.openingFallbackId = null;
    }

    const drawerInner = this.querySelector('.drawer__inner');
    if (this.openingTransitionHandler && drawerInner) {
      drawerInner.removeEventListener('transitionend', this.openingTransitionHandler);
    }
    this.openingTransitionHandler = null;
  }

  flushAfterOpenCallbacks() {
    const callbacks = this.afterOpenCallbacks || [];
    this.afterOpenCallbacks = [];
    callbacks.forEach((callback) => {
      if (typeof callback === 'function') callback();
    });
  }

  finishOpeningTransition() {
    this.cancelOpeningTransition();
    if (!this.classList.contains('active')) return;
    this.classList.remove('is-opening');
    this.classList.add('is-settled');
    this.flushAfterOpenCallbacks();
    this.dispatchEvent(new CustomEvent('cart-drawer:opened', { bubbles: true }));
  }

  scheduleAfterOpening(callback) {
    if (typeof callback === 'function') {
      this.afterOpenCallbacks.push(callback);
    }

    if (!this.classList.contains('is-opening')) {
      requestAnimationFrame(() => this.flushAfterOpenCallbacks());
      return;
    }

    if (this.openingTransitionHandler || this.openingFallbackId) return;

    const drawerInner = this.querySelector('.drawer__inner');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const finish = (event) => {
      if (event && event.target !== drawerInner) return;
      if (event && event.propertyName !== 'transform') return;
      this.finishOpeningTransition();
    };

    this.openingTransitionHandler = finish;
    if (drawerInner) {
      drawerInner.addEventListener('transitionend', finish);
    }
    this.openingFallbackId = setTimeout(finish, prefersReducedMotion ? 40 : 820);
  }

  open(triggeredBy, options = {}) {
    if (window.loadCartDrawerPanelStyles) window.loadCartDrawerPanelStyles();
    if (
      isEasyBundlePage() &&
      window.__dtEasyBundleCartDrawerOpenedOnce &&
      window.__dtEasyBundleCartDrawerDismissed &&
      !triggeredBy &&
      !options.force
    ) {
      return;
    }

    this.closeDrawerMiniTabs();

    // CRITICAL FIX: Remove any existing scroll prevention listeners before adding new ones
    // This prevents duplicate listeners when multiple products are added in quick succession
    if (this.preventBodyScroll) {
      document.removeEventListener('touchmove', this.preventBodyScroll);
      document.removeEventListener('wheel', this.preventBodyScroll);
      this.preventBodyScroll = null;
    }

    // If drawer is already open, don't re-initialize everything
    const isAlreadyOpen = this.classList.contains('active');
    const shouldAnimateOpen = !isAlreadyOpen && !this.dataset.openedOnce;
    if (!isAlreadyOpen) {
      if (shouldAnimateOpen) {
        this.startOpeningTransition();
      } else {
        this.skipOpeningTransition();
      }
    }

    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);

    // Hide floating WhatsApp buttons and other fixed elements on the right side
    this.hideFloatingButtons();

    // Prevent body scroll - store current scroll position (only if not already set)
    if (this.scrollY === undefined) {
      this.scrollY = window.scrollY;
    }

    // Only apply body scroll lock if drawer wasn't already open
    if (!isAlreadyOpen) {
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollY}px`;
      document.body.style.width = '100%';
      document.body.classList.add('overflow-hidden-drawer');
    }

    // Prevent body scroll while allowing drawer content to scroll
    // This handler prevents scroll events from reaching the body
    this.preventBodyScroll = (e) => {
      // Check if the event originated from within the drawer
      const drawer = this;
      const target = e.target;

      // Allow scrolling within scrollable drawer containers
      const scrollableSelectors = [
        '.cart_overflow',
        '.cart_overflow_inner',
        '.drawer__inner-empty',
        '.drawericon_sub',
        '.cart-drawer__recommendations-scroll',
        '.cart-routine-upsells__scroller'
      ];

      // Check if target is within any scrollable container
      let isInScrollableArea = false;
      for (const selector of scrollableSelectors) {
        const containers = drawer.querySelectorAll(selector);
        for (const container of containers) {
          if (container && (container === target || container.contains(target))) {
            isInScrollableArea = true;
            break;
          }
        }
        if (isInScrollableArea) break;
      }

      // If not in scrollable area, prevent the scroll event
      if (!isInScrollableArea) {
        e.preventDefault();
      }
    };

    // Add listeners for both touch and wheel events (only if not already open)
    if (!isAlreadyOpen) {
      document.addEventListener('touchmove', this.preventBodyScroll, { passive: false });
      document.addEventListener('wheel', this.preventBodyScroll, { passive: false });
    }

    if (!isAlreadyOpen) {
      prepareCartSavingsProgressIntro(this);
    }

    this.classList.add('animate');
    this.querySelector('.drawer__inner')?.getBoundingClientRect();
    this.classList.add('active');
    this.dataset.openedOnce = 'true';
    if (isEasyBundlePage()) {
      window.__dtEasyBundleCartDrawerOpenedOnce = true;
    }

    const afterOpen = () => {
      refreshCartSavingsProgressCollapseAfterPaint();
      playCartSavingsProgressIntro(this);
      const containerToTrapFocusOn = this.classList.contains('is-empty')
        ? this.querySelector('.drawer__inner-empty')
        : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
      if (typeof options.afterOpen === 'function') {
        options.afterOpen();
      }
    };

    this.scheduleAfterOpening(afterOpen);

    if (!options.skipRefresh && window.CartController && typeof window.CartController.refreshCartDrawerHTML === 'function') {
      this.scheduleAfterOpening(() => {
        const refreshCartState = (
          this.classList.contains('is-empty') &&
          typeof window.CartController.refreshCart === 'function'
        )
          ? window.CartController.refreshCart()
          : Promise.resolve();

        refreshCartState
          .then(() => window.CartController.refreshCartDrawerHTML())
          .then(refreshCartSavingsProgressCollapseAfterPaint)
          .catch(() => {});
      });
    }
  }

  close() {
    const wasActive = this.classList.contains('active');
    this.cancelOpeningTransition();
    this.afterOpenCallbacks = [];
    this.classList.remove('active', 'is-opening', 'is-settled');
    if (wasActive && isEasyBundlePage()) {
      window.__dtEasyBundleCartDrawerOpenedOnce = true;
      window.__dtEasyBundleCartDrawerDismissed = true;
    }
    removeTrapFocus(this.activeElement);

    // Restore body scroll
    document.body.classList.remove('overflow-hidden-drawer');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    // Restore scroll position
    if (this.scrollY !== undefined) {
      window.scrollTo(0, this.scrollY);
      this.scrollY = undefined;
    }

    // Remove event listeners
    if (this.preventBodyScroll) {
      document.removeEventListener('touchmove', this.preventBodyScroll);
      document.removeEventListener('wheel', this.preventBodyScroll);
      this.preventBodyScroll = null;
    }

    // Show floating WhatsApp buttons again
    this.showFloatingButtons();
  }

  hideFloatingButtons() {
    // Find and hide fixed elements (likely WhatsApp buttons/social widgets)
    // Avoid querySelectorAll('*') which causes massive performance hits
    const potentialFloating = document.querySelectorAll('body > *:not(script):not(style):not(cart-drawer):not(.dt-pdp-bundle-sheet), [class*="whatsapp"], [class*="wa-"], [id*="whatsapp"], [id*="wa-"], .social-sticky, .back-to-top');
    this.hiddenElements = [];

    potentialFloating.forEach((el) => {
      // Skip if element is part of cart drawer or already hidden
      if (this.contains(el) || el.classList.contains('dt-pdp-bundle-sheet') || el.hasAttribute('data-cart-drawer-hidden')) {
        return;
      }

      const style = window.getComputedStyle(el);
      const isFixed = style.position === 'fixed';
      const rightValue = style.right;
      const bottomValue = style.bottom;

      // Check if element is fixed and positioned on the right side
      if (isFixed && rightValue && rightValue !== 'auto') {
        const rightNum = parseFloat(rightValue);
        const bottomNum = bottomValue && bottomValue !== 'auto' ? parseFloat(bottomValue) : null;

        // Check for WhatsApp-related classes/ids
        const classList = Array.from(el.classList).join(' ').toLowerCase();
        const id = (el.id || '').toLowerCase();
        const isWhatsApp = classList.includes('whatsapp') ||
          classList.includes('wa-') ||
          id.includes('whatsapp') ||
          id.includes('wa-');

        // Hide if it's a WhatsApp button or if it's positioned on the right side near bottom
        // (typically floating buttons are within 0-150px from right edge)
        if (isWhatsApp || (rightNum >= 0 && rightNum <= 150 && bottomNum !== null && bottomNum >= 0 && bottomNum <= 200)) {
          if (style.display !== 'none' && style.visibility !== 'hidden') {
            el.setAttribute('data-cart-drawer-hidden', 'true');
            el.style.setProperty('display', 'none', 'important');
            this.hiddenElements.push(el);
          }
        }
      }
    });
  }

  showFloatingButtons() {
    // Restore hidden elements
    if (this.hiddenElements) {
      this.hiddenElements.forEach((el) => {
        if (el.hasAttribute('data-cart-drawer-hidden')) {
          el.style.removeProperty('display');
          el.removeAttribute('data-cart-drawer-hidden');
        }
      });
      this.hiddenElements = [];
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;

    // Fire AddToCart tracking for product-form / quick-add flows (abandoned cart recovery)
    if (window.CartController && typeof window.CartController.fireAddToCartTracking === 'function' && parsedState.items && parsedState.items.length > 0) {
      window.CartController.fireAddToCartTracking(parsedState);
    }
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      const sectionHTML = this.getSectionInnerHTML(parsedState.sections?.[section.id], section.selector);
      if (sectionElement && sectionHTML !== null) {
        sectionElement.innerHTML = sectionHTML;
      }
    });

    // Strip decimals from Liquid-rendered prices immediately after HTML replacement
    this.stripDecimalsFromPrices();
    refreshCartSavingsProgressCollapseAfterPaint();
    if (window.CartController?.cart && typeof window.CartController.updateOffersUI === 'function') {
      window.CartController.updateOffersUI();
    }

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // CRITICAL FIX: Only open drawer if it's not already open
      // This prevents duplicate event listeners when adding multiple products
      if (!this.classList.contains('active')) {
        this.open();
      }

      // Update progress bar after HTML replacement and DOM is ready
      // Check if parsedState has cart data directly or extract from sections
      if (parsedState) {
        const cartData = parsedState.total_price !== undefined ? parsedState : null;
        if (cartData) {
          this.updateTotals(cartData);

        } else {
          // Try to get cart total from the rendered HTML
          const progressBar = this.querySelector('.cart-progress-bar');
          if (progressBar && progressBar.dataset.cartTotal) {
            const cartTotal = parseInt(progressBar.dataset.cartTotal);
            this.updateTotals({ total_price: cartTotal });
          }
        }
      }
    });
  }

  /**
   * Strip decimal places from price strings
   */
  stripDecimalsFromPrices() {
    // Find all price elements in the cart drawer
    const priceSelectors = [
      '.price-breakdown__value',
      '.totals__total-value',
      '.totals__total-mrp',
      '.totals__saved-badge',
      '.cart-item__price',
      '.price'
    ];

    priceSelectors.forEach(selector => {
      const elements = this.querySelectorAll(selector);
      elements.forEach(element => {
        let text = element.textContent.trim();
        // Remove .00, .XX patterns (but keep numbers like 100, 1000)
        text = text.replace(/\.\d{2}(?=\s|$|,|\))/g, '');
        text = text.replace(/\.00(?=\s|$|,|\))/g, '');
        // Also handle currency formats like ₹1,234.56 -> ₹1,234
        text = text.replace(/(\d+),(\d+)\.\d{2}/g, '$1,$2');
        text = text.replace(/(\d+)\.\d{2}/g, '$1');
        if (text !== element.textContent.trim()) {
          element.textContent = text;
        }
      });
    });
  }

  updateTotals(cartData) {
    // If no cartData provided, fetch it
    if (!cartData || cartData.total_price === undefined) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(data => {
          this.updateTotals(data);
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
      return;
    }

    // Update cart total in drawer footer - use the formatted price from the response if available
    const totalValueElement = this.querySelector('.totals__total-value');
    if (totalValueElement && cartData.total_price !== undefined) {
      // The HTML replacement should already have the correct formatted price
      // But if it doesn't, we can format it here
      // Check if the element was already updated by HTML replacement
      const currentText = totalValueElement.textContent.trim();
      if (!currentText || currentText === '0' || currentText === '$0.00') {
        // Format the price - Shopify uses cents, so divide by 100
        // Use Shopify's currency format if available, otherwise use simple format
        const priceInCents = cartData.total_price;
        const price = priceInCents / 100;

        if (window.Shopify?.formatMoney) {
          let formatted = window.Shopify.formatMoney(priceInCents, window.money_format || '{{amount}}');
          // Remove decimal places
          formatted = formatted.replace(/\.\d{2}(?=\s|$|,|\))/g, '').replace(/\.00(?=\s|$|,|\))/g, '');
          formatted = formatted.replace(/(\d+),(\d+)\.\d{2}/g, '$1,$2').replace(/(\d+)\.\d{2}/g, '$1');
          totalValueElement.textContent = formatted;
        } else {
          // Fallback: check if currency_code_enabled setting exists
          const currencyEnabled = document.documentElement.dataset.currencyCodeEnabled === 'true';
          if (currencyEnabled && cartData.currency) {
            totalValueElement.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
              style: 'currency',
              currency: cartData.currency,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            }).format(price);
          } else {
            // Simple format with ₹ symbol (based on the theme's Indian currency)
            totalValueElement.textContent = `₹${price.toFixed(0)}`;
          }
        }
      }
    }

    // Update price breakdown coupon section and badge
    // Strip decimals from all prices after updating
    this.stripDecimalsFromPrices();
  }



  refreshSections() {
    const sections = this.getSectionsToRender().map((res) => res.id).join(',');
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then(response => response.json())
      .then(sectionsData => {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (sectionElement && sectionsData[section.id]) {
            const sectionHTML = this.getSectionInnerHTML(sectionsData[section.id], section.selector);
            if (sectionHTML !== null) {
              sectionElement.innerHTML = sectionHTML;
            }
          }
        });
        this.stripDecimalsFromPrices();
        refreshCartSavingsProgressCollapseAfterPaint();
      });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;

    const sectionRoot = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    if (!sectionRoot) return null;

    if (selector === '#CartDrawer') {
      const hasDrawerShell = sectionRoot.querySelector('.drawer__inner');
      const hasDrawerScrollArea = sectionRoot.querySelector('.cart_overflow_inner');
      const hasDrawerItems = sectionRoot.querySelector('cart-drawer-items');
      const hasDrawerForm = sectionRoot.querySelector('#CartDrawer-Form');

      if (!hasDrawerShell || !hasDrawerScrollArea || !hasDrawerItems || !hasDrawerForm) {
        return null;
      }
    }

    return sectionRoot.innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
};

window.CartDrawer = CartDrawer;

if (!customElements.get('cart-drawer')) {
  customElements.define('cart-drawer', CartDrawer);
}

function defineCartDrawerItems() {
  const BaseCartItems = window.CartItems || customElements.get('cart-items');

  if (!BaseCartItems) {
    window.addEventListener('theme:cart-ready', defineCartDrawerItems, { once: true });
    return;
  }

  if (customElements.get('cart-drawer-items')) return;

var CartDrawerItems = window.CartDrawerItems || class CartDrawerItems extends BaseCartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });
        refreshCartSavingsProgressCollapseAfterPaint();

        // Explicitly update line item prices and totals after HTML replacement
        // This ensures prices update even if HTML replacement has timing issues
        if (parsedState.items && parsedState.items.length > 0) {
          parsedState.items.forEach((item, index) => {
            const lineIndex = index + 1;
            const lineItem = document.getElementById(`CartDrawer-Item-${lineIndex}`);
            if (lineItem) {
              // Update line item price
              const priceWrapper = lineItem.querySelector('.cart-item__price-wrapper-inline .price');
              if (priceWrapper && item.final_line_price !== undefined) {
                const price = item.final_line_price / 100;
                const formattedPrice = `₹${price.toFixed(0)}`;
                const priceSpan = priceWrapper.querySelector('.price') || priceWrapper;
                if (priceSpan && priceSpan.textContent !== formattedPrice) {
                  priceSpan.textContent = formattedPrice;
                }
              }
            }
          });
        }

        // Update cart totals - the CartController now handles all pricing updates
        if (cartDrawerWrapper && cartDrawerWrapper.updateTotals && parsedState) {
          cartDrawerWrapper.updateTotals(parsedState);
        }

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('.drawer__close'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        }
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const removedLineIsGone = Number(quantity) === 0
          && !document.getElementById(`CartItem-${line}`)
          && !document.getElementById(`CartDrawer-Item-${line}`);
        if (removedLineIsGone) {
          const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
          if (errors) errors.textContent = '';
          return;
        }
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        if (errors) errors.textContent = window.cartStrings?.error || 'There was an error updating your cart.';
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }
};

window.CartDrawerItems = CartDrawerItems;

customElements.define('cart-drawer-items', CartDrawerItems);
}

defineCartDrawerItems();
